<template>
  <div class="">
    <b-card class="">
      <div class="d-flex flex-wrap align-items-center justify-content-between">
        <div class="d-flex mb-1 mb-sm-0 align-items-center">
          <h4
            class="d-flex align-items-center font-weight-bolder ml-1 text-nowrap mb-0"
          >
            <feather-icon
              class="mr-1"
              icon="ClipboardIcon"
              size="18"
            ></feather-icon>
            做客數據
          </h4>
        </div>
      </div>
      <div style="min-height: 80vh; display: grid; place-items: center">
        <b-row class="justify-content-center">
          <div class="info-item mr-2">
            <b class="">搜尋：</b
            ><span> {{ get_supplier_info.search_records_count }}次 </span>
          </div>
          <div class="info-item mr-2">
            <b class="">拒絕紀錄：</b
            ><span>{{ get_supplier_info.reject_records_count }}次</span>
          </div>
          <div class="info-item mr-2">
            <b class="">財務狀況：</b
            ><span>{{ get_supplier_info.client_loans_count }}次</span>
          </div>
          <div class="info-item mr-2">
            <b class="">帳務紀錄：</b
            ><span>{{ get_supplier_info.account_records_count }}次</span>
          </div>
          <div class="info-item mr-2">
            <b class="">無上傳記錄：</b><span>{{ calNoUpload }}次</span>
          </div>
          <div class="info-item">
            <b class="">上傳率：</b><span>{{ calUploadRate }}%</span>
          </div>
          <div class="info-item">
            <b class="">會員：</b
            ><span>{{ get_supplier_info.is_member ? "是" : "否" }}</span>
          </div>
          <div class="info-item">
            <b class="">會員到期日：</b
            ><span
              :class="{
                'text-danger font-weight-bold': isMembershipExpired,
              }"
              >{{ get_supplier_info.membership_expiry_date }}</span
            >
          </div>
          <div class="info-item">
            <b class="">搜尋剩餘次數：</b
            ><span>{{ get_supplier_info.search_limit }}次</span>
          </div>
        </b-row>
      </div>
    </b-card>
  </div>
</template>

<script>
import {
  BCard,
  BCardBody,
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BFormCheckbox,
  BButton,
  BTable,
  BMedia,
  BAvatar,
  BLink,
  BBadge,
  BDropdown,
  BDropdownItem,
  BPagination,
} from "bootstrap-vue";
import vSelect from "vue-select";
import store from "@/store";
import { ref, onUnmounted, computed } from "@vue/composition-api";
import useSuppliersInfo from "./useSuppliersInfo";
import supplierStoreModule from "../supplierStoreModule";
import { mapGetters } from "vuex";

export default {
  components: {
    BCard,
    BCardBody,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BFormCheckbox,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    vSelect,
  },
  data() {
    return {};
  },
  computed: {
    ...mapGetters({
      get_supplier_info: "app/get_supplier_info",
    }),
    // 檢查會員是否過期
    isMembershipExpired() {
      if (!this.get_supplier_info) return false;

      // 獲取當前日期和會員到期日
      const today = new Date();
      const expiryDate = new Date(
        this.get_supplier_info.membership_expiry_date
      );

      // 比較日期，如果當前日期大於會員到期日，則會員已過期
      return today > expiryDate;
    },
  },
  methods: {},
  setup() {
    const USER_APP_STORE_MODULE_NAME = "supplier-info";

    // Register module
    if (!store.hasModule(USER_APP_STORE_MODULE_NAME))
      store.registerModule(USER_APP_STORE_MODULE_NAME, supplierStoreModule);

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(USER_APP_STORE_MODULE_NAME))
        store.unregisterModule(USER_APP_STORE_MODULE_NAME);
    });

    const calUploadRate = computed(() => {
      const cal =
        Number(get_supplier_info.value.valid_client_count) /
        Number(get_supplier_info.value.account_records_count);
      cal > 1 ? 1 : cal;
      return cal * 100;
    });

    const calNoUpload = computed(() => {
      const cal =
        Number(get_supplier_info.value.client_count) -
        Number(get_supplier_info.value.valid_client_count) +
        Number(get_supplier_info.value.contract_count);
      return cal > 0 ? cal : 0;
    });

    const { ability } = useSuppliersInfo();

    return {
      ability,
      calUploadRate,
      calNoUpload,
    };
  },
};
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}
.info-item {
  font-size: 1.2rem;
  b {
    color: #676767;
  }
}

// @media screen and (max-width: 768px) {

// }
// @media screen and (max-width: 575px) {

// }
</style>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
@import "@/assets/scss/variables/_variables.scss";
</style>
